import { session } from '../Session';
import { fixRemoveStream } from '../../utils/fixRemoveStream';

export class SoftphoneStore {
    public async initialize(onInitialized: () => void): Promise<void> {
        if (session!.jwt) {
            if (await session!.fetchUser()) {
                if (await session!.fetchCredentials()) {
                    session!.loggedIn = true;
                    this.fixIceCandidatesTimeout();
                    fixRemoveStream();
                    onInitialized();
                } else {
                    session.logout();
                    session.addCantCallMessage();
                }
            } else {
                session.logout();
                session.addExpiredMessage();
            }
        }
    }

    private fixIceCandidatesTimeout(): void {
        // @ts-ignore
        tmedia_session_jsep01.onIceCandidate = function (o_event, _this) {
            // @ts-ignore
            const that = (tmedia_session_jsep01.mozThis || _this);
            if (!that || !that.o_pc) {
                // @ts-ignore
                tsk_utils_log_error("This/PeerConnection is null: unexpected");
                return;
            }
            const iceState = (that.o_pc.iceGatheringState || that.o_pc.iceState);

            // @ts-ignore
            tsk_utils_log_info("onIceCandidate = " + iceState);

            // @ts-ignore
            if (!tmedia_session_jsep01.ice_timer) {
                // @ts-ignore
                tmedia_session_jsep01.ice_timer = setTimeout(function(): void {
                    console.log("ICE timer...");
                    // @ts-ignore
                    tmedia_session_jsep01.onIceGatheringCompleted(that);
                    // @ts-ignore
                    tmedia_session_jsep01.ice_timer = null;
                },0);
            }

            if (iceState === "complete" || (o_event && !o_event.candidate)) {
                // @ts-ignore
                tsk_utils_log_info("ICE GATHERING COMPLETED!");
                // @ts-ignore
                tmedia_session_jsep01.onIceGatheringCompleted(that);
            }
            else if (that.o_pc.iceState === "failed") {
                // @ts-ignore
                tsk_utils_log_error("Ice state is 'failed'");
                // @ts-ignore
                that.o_mgr.callback(tmedia_session_events_e.GET_LO_FAILED, that.e_type);
            }
        }
    }
}

export const softphoneStore = new SoftphoneStore();
